/**
 * @generated SignedSource<<f65eabe02d74079a1583444a47d6da62>>
 * @relayHash c49f8a27f2927fb4673e70474295efe2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-15T19:15:12.814Z/getFeatureFlagsQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type getFeatureFlagsQuery$variables = {};
export type getFeatureFlagsQuery$data = {
  readonly viewer: {
    readonly googleOneTapAutoLogin: boolean | null;
  };
};
export type getFeatureFlagsQuery = {
  response: getFeatureFlagsQuery$data;
  variables: getFeatureFlagsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "googleOneTapAutoLogin",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "googleOneTapAutoLogin"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"googleOneTapAutoLogin\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "getFeatureFlagsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "getFeatureFlagsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-15T19:15:12.814Z/getFeatureFlagsQuery",
    "metadata": {},
    "name": "getFeatureFlagsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "49d394bb81e682c7a09f1334108bfe28";

export default node;
